export default "__VITE_ASSET__pc55U0AC__"